import './style.scss';
document.addEventListener('DOMContentLoaded', init);
/**
 * Initialize the script
 */
function init() {
    isAccountNewlyCreated();
    checkUrlFragment();
    setupSteps();
    setupLogin();
    setupForgotPassword();
    setupOtp();
    setupChangePassword();
    setupCreateAccount();
    setupModals();
    window.addEventListener('hashchange', checkUrlFragment);
}
/**
 * Check if account is newly created
 */
function isAccountNewlyCreated() {
    const urlParams = new URLSearchParams(window.location.search);
    const accountCreated = urlParams.get('konto-skapat');
    if (!isNullOrUndefined(accountCreated)) {
        const successBox = document.querySelector('[data-id="create-account-success"]');
        successBox?.classList.add('alert--active');
    }
}
function checkUrlFragment() {
    let fragment = window.location.hash;
    fragment = fragment.replace('#', '');
    if (fragment === 'glomt-losenord') {
        updateSliderPosition(2);
    }
    else if (fragment === 'skapa-konto') {
        updateSliderPosition(5);
    }
}
/**
 * Setup steps
 */
function setupSteps() {
    const stepBtns = document.querySelectorAll('[data-button]');
    stepBtns.forEach((btn) => {
        if (!(btn instanceof HTMLElement)) {
            return;
        }
        btn.addEventListener('click', () => {
            const targetStep = parseInt(btn.dataset.targetStep ?? '', 10);
            updateSliderPosition(targetStep);
        });
    });
}
/**
 * Setup login functionality
 */
function setupLogin() {
    const inputEmail = document.querySelector('input[type="email"][name="username"]');
    const inputPassword = document.querySelector('input[type="password"][name="password"]');
    const btnLogin = document.querySelector('[data-id="btn-login"]');
    const btnLoginBankId = document.querySelector('[data-id="btn-bankid"]');
    const errorBox = document.querySelector('[data-id="login-error"]');
    if (!(inputEmail instanceof HTMLInputElement) ||
        !(inputPassword instanceof HTMLInputElement) ||
        !(btnLogin instanceof HTMLDivElement) ||
        !(btnLoginBankId instanceof HTMLAnchorElement) ||
        !(errorBox instanceof HTMLDivElement)) {
        return;
    }
    btnLogin?.addEventListener('click', (e) => {
        void btnLoginClick(btnLogin, inputEmail, inputPassword, errorBox);
    });
    btnLoginBankId?.addEventListener('click', () => {
        setBtnLoadingState(btnLoginBankId, true);
    });
    inputEmail?.addEventListener('keyup', (e) => {
        inputEmailKeyup(e, btnLogin);
    });
    inputEmail?.addEventListener('keydown', (e) => {
        inputEmailKeyDown(e, inputPassword);
    });
    inputPassword?.addEventListener('keyup', (e) => {
        inputPasswordKeyUp(e, btnLogin);
    });
    inputPassword?.addEventListener('keydown', (e) => {
        inputPasswordKeyDown(e, inputEmail);
    });
}
/**
 * Handle login button click
 *
 * @param btnLogin HTMLDivElement - Login button
 * @param inputEmail HTMLInputElement - Email input
 * @param inputPassword HTMLInputElement - Password input
 * @param errorBox HTMLDivElement - Error box
 */
async function btnLoginClick(btnLogin, inputEmail, inputPassword, errorBox) {
    if (btnLogin.dataset.clicked === 'true') {
        return;
    }
    const username = inputEmail.value.trim();
    const password = inputPassword.value.trim();
    if (isNullOrWhitespace(username) || isNullOrWhitespace(password)) {
        errorBox.classList.add('alert--active');
        return;
    }
    setBtnLoadingState(btnLogin, true);
    try {
        const response = await window.fetch('/custom/authenticate/login/index.aspx/DoLogin', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ email: username, password, personalNumber: '' })
        });
        if (!response.ok) {
            throw Error('Ett oväntat fel uppstod. Ladda om sidan eller försök igen senare.');
        }
        const data = await response.json();
        const dataParsed = JSON.parse(data.d);
        if (dataParsed?.StatusCode !== 200) {
            throw dataParsed;
        }
        // Extract the redirect URL from the current page's query parameters
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('redirect')) {
            const redirectUrl = urlParams.get('redirect');
            console.log(redirectUrl);
            if (redirectUrl !== null) {
                window.location.href = `/?redirect=${encodeURIComponent(redirectUrl)}`;
            }
        }
        window.location.href = '/?logged-in';
    }
    catch (error) {
        console.error(error);
        setBtnLoadingState(btnLogin, false);
        const errorMessage = error instanceof Error
            ? error.message
            : isBackendError(error)
                ? error.Message
                : 'Ett oväntat fel uppstod. Försök igen senare.';
        setErrorMessage(errorBox, errorMessage);
    }
}
/**
 * Handle keyup event on email input
 *
 * @param e Event
 * @param btnLogin HTMLDivElement
 */
function inputEmailKeyup(e, btnLogin) {
    if (!(e instanceof KeyboardEvent)) {
        return;
    }
    if (e.key === 'Enter') {
        e.preventDefault();
        btnLogin.click();
    }
}
/**
 * Handle keydown event on email input
 *
 * @param e Event
 * @param inputPassword HTMLInputElement
 */
function inputEmailKeyDown(e, inputPassword) {
    if (!(e instanceof KeyboardEvent)) {
        return;
    }
    if (e.key === 'Tab') {
        e.preventDefault();
        inputPassword.focus();
    }
}
/**
 * Handle keyup event on password input
 *
 * @param e Event
 * @param btnLogin HTMLDivElement
 */
function inputPasswordKeyUp(e, btnLogin) {
    if (!(e instanceof KeyboardEvent)) {
        return;
    }
    if (e.key === 'Enter') {
        e.preventDefault();
        btnLogin.click();
    }
}
/**
 * Handle keydown event on password input
 *
 * @param e Event
 * @param inputEmail HTMLInputElement
 */
function inputPasswordKeyDown(e, inputEmail) {
    if (!(e instanceof KeyboardEvent)) {
        return;
    }
    if (e.key === 'Tab') {
        e.preventDefault();
        inputEmail.focus();
    }
}
/**
 * Setup forgot password functionality
 */
function setupForgotPassword() {
    const sendBtn = document.querySelector('[data-id="btn-reset-password"]');
    const emailInput = document.querySelector('[data-id="input-reset-password"]');
    const errorBox = document.querySelector('[data-id="password-reset-error"]');
    if (!(sendBtn instanceof HTMLDivElement) ||
        !(emailInput instanceof HTMLInputElement) ||
        !(errorBox instanceof HTMLDivElement)) {
        return;
    }
    sendBtn.addEventListener('click', (e) => {
        void sendBtnClick(sendBtn, emailInput, errorBox);
    });
    emailInput.addEventListener('keyup', (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            void sendBtnClick(sendBtn, emailInput, errorBox);
        }
    });
    emailInput.addEventListener('keydown', (e) => {
        if (e.key === 'Tab') {
            e.preventDefault();
        }
    });
}
/**
 * Handle send button click
 *
 * @param sendBtn HTMLDivElement
 * @param emailInput HTMLInputElement
 * @param errorBox HTMLDivElement
 */
async function sendBtnClick(sendBtn, emailInput, errorBox) {
    if (sendBtn.dataset.clicked === 'true' || emailInput.value === '') {
        return;
    }
    setBtnLoadingState(sendBtn, true);
    try {
        const response = await window.fetch('/custom/authenticate/login/index.aspx/ResetPassword', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                email: emailInput.value
            })
        });
        if (!response.ok) {
            throw Error('Ett oväntat fel uppstod. Ladda om sidan eller försök igen senare.');
        }
        const data = await response.json();
        const dataParsed = JSON.parse(data.d);
        if (dataParsed.StatusCode !== 200) {
            throw dataParsed;
        }
        updateSliderPosition(parseInt(sendBtn.dataset.targetStep ?? '0'));
        removeErrorMessage(errorBox);
    }
    catch (error) {
        console.error(error);
        const errorMessage = error instanceof Error
            ? error.message
            : isBackendError(error)
                ? error.Message
                : 'Ett oväntat fel uppstod. Försök igen senare.';
        setErrorMessage(errorBox, errorMessage);
    }
    finally {
        setBtnLoadingState(sendBtn, false);
    }
}
/**
 * Setup one time password functionality
 */
function setupOtp() {
    const input = document.querySelector('[data-id="one-time-code"]');
    const sendBtn = document.querySelector('[data-id="btn-send-otp"]');
    const errorBox = document.querySelector('[data-id="otp-error"]');
    if (!(input instanceof HTMLInputElement) ||
        !(sendBtn instanceof HTMLDivElement) ||
        !(errorBox instanceof HTMLDivElement)) {
        return;
    }
    input.addEventListener('input', () => {
        const selectionStart = input.selectionStart ?? 0;
        input.style.setProperty('--_otp-digit', selectionStart.toString()); // update css variable to show input position
    });
    sendBtn.addEventListener('click', (e) => {
        void btnSendOtpClick(sendBtn, input, errorBox);
    });
}
/**
 * Handle send otp button click
 *
 * @param sendBtn HTMLDivElement
 * @param otpInput HTMLInputElement
 * @param errorBox HTMLDivElement
 */
async function btnSendOtpClick(sendBtn, otpInput, errorBox) {
    if (sendBtn.dataset.clicked === 'true' || otpInput.value.length !== 6) {
        return;
    }
    try {
        const emailInput = document.querySelector('[data-id="input-reset-password"]');
        if (!(emailInput instanceof HTMLInputElement)) {
            throw new Error('E-postadress saknas eller är ogiltig');
        }
        const email = emailInput.value ?? '';
        const otp = parseInt(otpInput.value);
        if (isNullOrWhitespace(email)) {
            throw Error('E-postadress saknas eller är ogiltig');
        }
        else if (isNaN(otp) || otp.toString().length !== 6) {
            throw Error('Koden du angav är inte giltig');
        }
        setBtnLoadingState(sendBtn, true);
        const response = await window.fetch('/custom/authenticate/login/index.aspx/ValidateOtp', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                email,
                code: otp
            })
        });
        if (!response.ok) {
            throw Error('Ett oväntat fel uppstod. Ladda om sidan eller försök igen senare.');
        }
        const data = await response.json();
        const dataParsed = JSON.parse(data.d);
        if (dataParsed?.StatusCode !== 200) {
            throw dataParsed;
        }
        if (dataParsed?.StatusCode === 200) {
            updateSliderPosition(parseInt(sendBtn.dataset.targetStep ?? ''));
            removeErrorMessage(errorBox);
        }
    }
    catch (error) {
        console.error(error);
        const errorMessage = error instanceof Error
            ? error.message
            : isBackendError(error)
                ? error.Message
                : 'Ett oväntat fel uppstod. Försök igen senare.';
        setErrorMessage(errorBox, errorMessage);
    }
    finally {
        setBtnLoadingState(sendBtn, false);
    }
}
/**
 * Setup change password functionality
 */
function setupChangePassword() {
    const btnConfirm = document.querySelector('[data-id="btn-update-password"]');
    const inputNewPassword = document.querySelector('input[type="password"][name="new-password"]');
    const inputConfirmPassword = document.querySelector('input[type="password"][name="new-password-confirm"]');
    const inputOtp = document.querySelector('[data-id="one-time-code"]');
    const inputEmail = document.querySelector('[data-id="input-reset-password"]');
    const errorBox = document.querySelector('[data-id="new-password-error"]');
    if (!(btnConfirm instanceof HTMLDivElement) ||
        !(inputNewPassword instanceof HTMLInputElement) ||
        !(inputConfirmPassword instanceof HTMLInputElement) ||
        !(inputOtp instanceof HTMLInputElement) ||
        !(inputEmail instanceof HTMLInputElement) ||
        !(errorBox instanceof HTMLDivElement)) {
        return;
    }
    btnConfirm.addEventListener('click', (e) => {
        void btnConfirmNewPasswordClick(btnConfirm, inputNewPassword, inputConfirmPassword, inputOtp, inputEmail, errorBox);
    });
    inputNewPassword.addEventListener('keydown', (event) => {
        if (event.key === 'Tab') {
            event.preventDefault();
            inputConfirmPassword.focus();
        }
    });
    inputNewPassword.addEventListener('keyup', (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            btnConfirm.click();
        }
    });
    inputConfirmPassword.addEventListener('keydown', (event) => {
        if (event.key === 'Tab') {
            event.preventDefault();
            inputNewPassword.focus();
        }
    });
    inputConfirmPassword.addEventListener('keyup', (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            btnConfirm.click();
        }
    });
}
/**
 * Handle confirm new password button click
 *
 * @param btnConfirm HTMLDivElement
 * @param inputNewPassword HTMLInputElement
 * @param inputConfirmPassword HTMLInputElement
 * @param inputOtp HTMLInputElement
 * @param inputEmail HTMLInputElement
 * @param errorBox HTMLDivElement
 */
async function btnConfirmNewPasswordClick(btnConfirm, inputNewPassword, inputConfirmPassword, inputOtp, inputEmail, errorBox) {
    if (btnConfirm.dataset.clicked === 'true' || inputNewPassword.value === '' || inputConfirmPassword.value === '') {
        return;
    }
    try {
        const p1 = inputNewPassword.value;
        const p2 = inputConfirmPassword.value;
        const otp = parseInt(inputOtp.value);
        const email = inputEmail.value;
        if (p1 !== p2) {
            throw Error('Lösenorden matchar inte');
        }
        else if (isNaN(otp) || otp.toString().length !== 6) {
            throw Error('Koden du angav är inte giltig');
        }
        else if (isNullOrWhitespace(email)) {
            throw Error('E-postadress saknas eller är ogiltig');
        }
        setBtnLoadingState(btnConfirm, true);
        const response = await window.fetch('/custom/authenticate/login/index.aspx/UpdatePassword', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                email,
                password: p1,
                otp
            })
        });
        if (!response.ok) {
            throw Error('Ett oväntat fel uppstod. Ladda om sidan eller försök igen senare.');
        }
        const data = await response.json();
        const dataParsed = JSON.parse(data.d);
        if (dataParsed?.StatusCode !== 200) {
            throw dataParsed;
        }
        newPasswordSuccess();
    }
    catch (error) {
        console.error(error);
        const errorMessage = error instanceof Error
            ? error.message
            : isBackendError(error)
                ? error.Message
                : 'Ett oväntat fel uppstod. Försök igen senare.';
        setErrorMessage(errorBox, errorMessage);
    }
    finally {
        setBtnLoadingState(btnConfirm, false);
    }
}
/**
 * Show success message after changing password
 */
function newPasswordSuccess() {
    const successBox = document.querySelector('[data-id="new-password-success"]');
    successBox?.classList.add('alert--active');
    updateSliderPosition(1);
}
function setupCreateAccount() {
    setupFirstStep();
    setupSecondStep();
    setupThirdStep();
    /**
     * Setup first step of create account
     */
    function setupFirstStep() {
        const btnNext = document.querySelector('[data-id="btn-create-account-proceed"]');
        const inputCompanyNumber = document.querySelector('input[name="create-account-company-number"]');
        const inputPersonalNumber = document.querySelector('input[name="create-account-personal-number"]');
        const errorBox = document.querySelector('[data-id="create-account-error"]');
        if (!(btnNext instanceof HTMLDivElement) ||
            !(inputCompanyNumber instanceof HTMLInputElement) ||
            !(inputPersonalNumber instanceof HTMLInputElement) ||
            !(errorBox instanceof HTMLDivElement)) {
            return;
        }
        btnNext.addEventListener('click', (e) => {
            void btnCreateAccountProceedStep1Click(btnNext, inputCompanyNumber, inputPersonalNumber, errorBox);
        });
        inputCompanyNumber.addEventListener('input', () => {
            inputCompanyNumber.value = inputCompanyNumber.value.replace(/\D/g, ''); // Remove all non-numeric characters
        });
        inputCompanyNumber.addEventListener('keydown', (e) => {
            if (e.key === 'Tab') {
                e.preventDefault();
                inputPersonalNumber.focus();
            }
        });
        inputCompanyNumber.addEventListener('keyup', (e) => {
            if (e.key === 'Enter') {
                e.preventDefault();
                void btnCreateAccountProceedStep1Click(btnNext, inputCompanyNumber, inputPersonalNumber, errorBox);
            }
        });
        inputPersonalNumber.addEventListener('keydown', (e) => {
            if (e.key === 'Tab') {
                e.preventDefault();
                inputCompanyNumber.focus();
            }
        });
        inputPersonalNumber.addEventListener('keyup', (e) => {
            if (e.key === 'Enter') {
                e.preventDefault();
                void btnCreateAccountProceedStep1Click(btnNext, inputCompanyNumber, inputPersonalNumber, errorBox);
            }
        });
    }
    /**
     * Setup second step of create account
     */
    function setupSecondStep() {
        const inputEmail = document.querySelector('input[name="create-account-email"]');
        const inputPhone = document.querySelector('input[name="create-account-phone"]');
        const btnNext = document.querySelector('[data-id="btn-create-account-proceed-2"]');
        const errorBox = document.querySelector('[data-id="create-account-error-2"]');
        if (!(inputEmail instanceof HTMLInputElement) ||
            !(inputPhone instanceof HTMLInputElement) ||
            !(btnNext instanceof HTMLDivElement) ||
            !(errorBox instanceof HTMLDivElement)) {
            return;
        }
        btnNext.addEventListener('click', () => {
            void btnCreateAccountProceedStep2Click(btnNext, inputEmail, inputPhone, errorBox);
        });
        inputEmail.addEventListener('keydown', (e) => {
            if (e.key === 'Tab') {
                e.preventDefault();
                inputPhone.focus();
            }
        });
        inputEmail.addEventListener('keyup', (e) => {
            if (e.key === 'Enter') {
                e.preventDefault();
                void btnCreateAccountProceedStep2Click(btnNext, inputEmail, inputPhone, errorBox);
            }
        });
        inputPhone.addEventListener('keydown', (e) => {
            if (e.key === 'Tab') {
                e.preventDefault();
                inputEmail.focus();
            }
        });
        inputPhone.addEventListener('keyup', (e) => {
            if (e.key === 'Enter') {
                e.preventDefault();
                void btnCreateAccountProceedStep2Click(btnNext, inputEmail, inputPhone, errorBox);
            }
        });
    }
    function setupThirdStep() {
        const inputPassword = document.querySelector('input[name="create-account-password"]');
        const inputConfirmPassword = document.querySelector('input[name="create-account-password-confirm"]');
        const inputTerms = document.querySelector('input[name="create-account-terms"]');
        const btnCreate = document.querySelector('[data-id="btn-create-account"]');
        const errorBox = document.querySelector('[data-id="create-account-error-3"]');
        const reqUppercase = document.querySelector('[data-password-req="uppercase"]');
        const reqNumber = document.querySelector('[data-password-req="number"]');
        const reqLength = document.querySelector('[data-password-req="length"]');
        if (!(inputPassword instanceof HTMLInputElement) ||
            !(inputConfirmPassword instanceof HTMLInputElement) ||
            !(inputTerms instanceof HTMLInputElement) ||
            !(btnCreate instanceof HTMLDivElement) ||
            !(errorBox instanceof HTMLDivElement) ||
            !(reqUppercase instanceof HTMLElement) ||
            !(reqNumber instanceof HTMLElement) ||
            !(reqLength instanceof HTMLElement)) {
            return;
        }
        inputPassword.addEventListener('input', (e) => {
            if (e.target === null || !(e.target instanceof HTMLInputElement)) {
                return;
            }
            e.target.value = e.target.value.replace(/\s/g, '').trim(); // remove all whitespace
            const hasUpperCase = /[A-Z]/.test(e.target.value);
            const hasNumber = /\d/.test(e.target.value);
            const hasLength = e.target.value.length >= 6;
            reqUppercase.classList.toggle('valid', hasUpperCase);
            reqNumber.classList.toggle('valid', hasNumber);
            reqLength.classList.toggle('valid', hasLength);
            if (inputConfirmPassword.value !== '') {
                inputConfirmPassword.dispatchEvent(new Event('input'));
            }
        });
        inputConfirmPassword.addEventListener('input', (e) => {
            if (e.target === null || !(e.target instanceof HTMLInputElement)) {
                return;
            }
            e.target.value = e.target.value.replace(/\s/g, '').trim(); // remove all whitespace
        });
        inputPassword.addEventListener('keydown', (e) => {
            if (e.key === 'Tab') {
                e.preventDefault();
                inputConfirmPassword.focus();
            }
        });
        inputPassword.addEventListener('keyup', (e) => {
            if (e.key === 'Enter') {
                e.preventDefault();
                void btnCreateAccountClick(btnCreate, inputPassword, inputConfirmPassword, inputTerms, errorBox);
            }
        });
        inputConfirmPassword.addEventListener('keydown', (e) => {
            if (e.key === 'Tab') {
                e.preventDefault();
                inputPassword.focus();
            }
        });
        inputConfirmPassword.addEventListener('keyup', (e) => {
            if (e.key === 'Enter') {
                e.preventDefault();
                void btnCreateAccountClick(btnCreate, inputPassword, inputConfirmPassword, inputTerms, errorBox);
            }
        });
        btnCreate.addEventListener('click', () => {
            void btnCreateAccountClick(btnCreate, inputPassword, inputConfirmPassword, inputTerms, errorBox);
        });
    }
}
/**
 * Handle create account proceed button click
 *
 * @param btn HTMLDivElement
 * @param inputCompanyNumber HTMLInputElement
 * @param inputPersonalNumber HTMLInputElement
 * @param errorBox HTMLDivElement
 * @returns Promise<void>
 */
async function btnCreateAccountProceedStep1Click(btn, inputCompanyNumber, inputPersonalNumber, errorBox) {
    if (btn.dataset.clicked === 'true') {
        return;
    }
    setBtnLoadingState(btn, true);
    try {
        const companyNumber = inputCompanyNumber.value.trim();
        const personalNumber = inputPersonalNumber.value.trim();
        if (isNullOrWhitespace(companyNumber)) {
            throw Error('Fyll i företagsnummer');
        }
        if (isNaN(parseInt(companyNumber))) {
            throw Error('Företagsnumret är inte giltigt');
        }
        if (isNullOrWhitespace(personalNumber)) {
            throw Error('Fyll i personnummer');
        }
        const response = await window.fetch('/custom/authenticate/login/index.aspx/ValidateCreateAccountCompanyAndPersonalNumber', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                companyNumber,
                personalNumber
            })
        });
        if (!response.ok) {
            throw Error('Ett oväntat fel uppstod. Ladda om sidan eller försök igen senare.');
        }
        const data = await response.json();
        const dataParsed = JSON.parse(data.d);
        if (dataParsed.StatusCode !== 200) {
            throw dataParsed;
        }
        if (typeof dataParsed.Message !== 'object') {
            throw Error('Ett oväntat fel uppstod. Ladda om sidan eller försök igen senare.');
        }
        if (isPersonObject(dataParsed.Message)) {
            updateCreateAccountFields(dataParsed.Message);
        }
        updateSliderPosition(parseInt(btn.dataset.targetStep ?? '0'));
        removeErrorMessage(errorBox);
    }
    catch (error) {
        console.error(error);
        const errorMessage = error instanceof Error
            ? error.message
            : isBackendError(error)
                ? error.Message
                : 'Ett oväntat fel uppstod. Försök igen senare.';
        setErrorMessage(errorBox, errorMessage);
    }
    finally {
        setBtnLoadingState(btn, false);
    }
}
async function btnCreateAccountProceedStep2Click(btn, inputEmail, inputPhone, errorBox) {
    if (btn.dataset.clicked === 'true') {
        return;
    }
    setBtnLoadingState(btn, true);
    try {
        const email = inputEmail.value.trim();
        const phone = inputPhone.value.trim().replace(/[\s-]+/g, ''); // Remove all whitespace and hyphens
        if (isNullOrWhitespace(email) || !isValidEmail(email)) {
            throw Error('Fyll i en giltig e-postadress');
        }
        if (isNullOrWhitespace(phone) || !isValidPhone(phone)) {
            throw Error('Fyll i ett giltigt telefonnummer');
        }
        const response = await window.fetch('/custom/authenticate/login/index.aspx/ValidateCreateAccountEmailAndPhone', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                email,
                phone
            })
        });
        if (!response.ok) {
            throw Error('Ett oväntat fel uppstod. Ladda om sidan eller försök igen senare.');
        }
        const data = await response.json();
        const dataParsed = JSON.parse(data.d);
        if (dataParsed.StatusCode !== 200) {
            throw dataParsed;
        }
        updateSliderPosition(parseInt(btn.dataset.targetStep ?? '0'));
    }
    catch (error) {
        console.error(error);
        const errorMessage = error instanceof Error
            ? error.message
            : isBackendError(error)
                ? error.Message
                : 'Ett oväntat fel uppstod. Försök igen senare.';
        setErrorMessage(errorBox, errorMessage);
        window.scrollTo(0, 0); // scroll to top of page
    }
    finally {
        setBtnLoadingState(btn, false);
    }
}
async function btnCreateAccountClick(btn, inputPassword, inputPasswordConfirm, inputTerms, errorBox) {
    if (btn.dataset.clicked === 'true') {
        return;
    }
    setBtnLoadingState(btn, true);
    try {
        if (!inputTerms.checked) {
            throw Error('Du måste acceptera villkoren för att skapa ett konto');
        }
        const hasUpperCase = /[A-Z]/.test(inputPassword.value);
        const hasNumber = /\d/.test(inputPassword.value);
        const hasLength = inputPassword.value.length >= 6;
        if (!hasUpperCase || !hasNumber || !hasLength) {
            throw Error('Lösenordet måste innehålla minst 6 tecken, varav minst en siffra och en stor bokstav');
        }
        if (inputPassword.value !== inputPasswordConfirm.value) {
            throw Error('Lösenorden matchar inte');
        }
        const inputCompanyNumber = document.querySelector('input[name="create-account-company-number"]');
        const inputPersonalNumber = document.querySelector('input[name="create-account-personal-number"]');
        const inputEmail = document.querySelector('input[name="create-account-email"]');
        const inputPhone = document.querySelector('input[name="create-account-phone"]');
        if (!(inputCompanyNumber instanceof HTMLInputElement) ||
            !(inputPersonalNumber instanceof HTMLInputElement) ||
            !(inputEmail instanceof HTMLInputElement) ||
            !(inputPhone instanceof HTMLInputElement)) {
            throw Error('Ett oväntat fel uppstod. Ladda om sidan eller försök igen senare.');
        }
        const response = await window.fetch('/custom/authenticate/login/index.aspx/CreateAccount', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                companyNumber: inputCompanyNumber.value,
                personalNumber: inputPersonalNumber.value,
                email: inputEmail.value,
                phone: inputPhone.value,
                password: inputPassword.value
            })
        });
        if (!response.ok) {
            throw Error('Ett oväntat fel uppstod. Ladda om sidan eller försök igen senare.');
        }
        const data = await response.json();
        const dataParsed = JSON.parse(data.d);
        if (dataParsed.StatusCode !== 200) {
            throw dataParsed;
        }
        window.dataLayer = isNullOrUndefined(window.dataLayer) ? [] : window.dataLayer;
        window.dataLayer.push({
            event: 'account_created'
        });
        window.location.href = '/logga-in?konto-skapat';
    }
    catch (error) {
        console.error(error);
        const errorMessage = error instanceof Error
            ? error.message
            : isBackendError(error)
                ? error.Message
                : 'Ett oväntat fel uppstod. Försök igen senare.';
        setErrorMessage(errorBox, errorMessage);
    }
    finally {
        setBtnLoadingState(btn, false);
    }
}
/**
 * Update create account fields with data from backend
 *
 * @param data PersonObject
 */
function updateCreateAccountFields(data) {
    const inputDummyIds = [
        { id: '[data-id="create-account-first-name"]', value: data.FirstName },
        { id: '[data-id="create-account-last-name"]', value: data.LastName },
        { id: '[data-id="create-account-role"]', value: data.Position === '' ? 'Ej satt' : data.Position },
        { id: '[data-id="create-account-company"]', value: data.Company }
    ];
    const inputs = [
        {
            id: 'input[name="create-account-email"]',
            value: data.Email
        },
        {
            id: 'input[name="create-account-phone"]',
            value: data.MobilePhone
        }
    ];
    inputDummyIds.forEach((i) => {
        const p = document.querySelector(i.id);
        if (!(p instanceof HTMLParagraphElement)) {
            return;
        }
        p.textContent = i.value;
    });
    inputs.forEach((i) => {
        const input = document.querySelector(i.id);
        if (!(input instanceof HTMLInputElement)) {
            return;
        }
        input.value = i.value;
    });
}
/**
 * Setup modals
 */
function setupModals() {
    const modalBtns = document.querySelectorAll('[data-modal-target]');
    modalBtns.forEach((btn) => {
        if (!(btn instanceof HTMLElement)) {
            return;
        }
        const modal = document.querySelector(`[data-id="${btn.dataset.modalTarget}"]`);
        if (modal === null) {
            return;
        }
        btn.addEventListener('click', () => {
            modal.classList.add('modal--open');
        });
        const inner = modal.querySelector('.modal__inner');
        const closeBtns = modal.querySelectorAll('[data-id="modal-close"]');
        if (inner === null) {
            return;
        }
        modal.addEventListener('click', (e) => {
            if (!(e.target instanceof Node)) {
                return;
            }
            if (inner.contains(e.target)) {
                return;
            }
            modal.classList.remove('modal--open');
        });
        closeBtns.forEach((closeBtn) => {
            closeBtn.addEventListener('click', () => {
                modal.classList.remove('modal--open');
            });
        });
    });
}
/**
 * Update slider position to show current step
 *
 * @param currentStep
 */
function updateSliderPosition(currentStep) {
    const steps = document.querySelectorAll('[data-step]');
    const stepWrapper = document.querySelector('[data-step-wrapper]');
    if (!(stepWrapper instanceof HTMLDivElement)) {
        return;
    }
    const thisStep = steps[currentStep];
    steps.forEach((step) => {
        if (!(step instanceof HTMLDivElement)) {
            return;
        }
        step.classList.remove('step--visible');
        if (step === thisStep) {
            step.classList.add('step--visible');
        }
    });
    const slideWidth = steps[0].clientWidth;
    stepWrapper.style.transform = `translateX(${-slideWidth * currentStep}px)`;
}
/**
 * Set loading state of a custom button
 *
 * @param btn
 * @param isLoading
 */
function setBtnLoadingState(btn, isLoading) {
    const btnText = btn.querySelector('span');
    const btnSpinner = btn.querySelector('i');
    if (isLoading) {
        btn.dataset.clicked = 'true';
        btnText.classList.add('hidden');
        btnSpinner?.classList.remove('hidden');
        return;
    }
    btn.dataset.clicked = 'false';
    btnText.classList.remove('hidden');
    btnSpinner?.classList.add('hidden');
}
/**
 * Sett error message in error box
 *
 * @param errorBox
 * @param message
 */
function setErrorMessage(errorBox, message) {
    const errorBoxText = errorBox.querySelector('span');
    if (errorBoxText === null) {
        return;
    }
    errorBoxText.innerHTML = message;
    errorBox.classList.add('alert--active');
}
/**
 * Remove error message from error box
 *
 * @param errorBox
 */
function removeErrorMessage(errorBox) {
    errorBox.classList.remove('alert--active');
}
/**
 * Check if string is null or whitespace
 *
 * @param input
 */
function isNullOrWhitespace(input) {
    if (input === null || input === undefined) {
        return true;
    }
    return input.trim().length === 0;
}
/**
 * Check if value is null or undefined
 */
function isNullOrUndefined(value) {
    return value === null || value === undefined;
}
/**
 * Validate email
 *
 * @param email
 * @returns boolean
 */
function isValidEmail(email) {
    return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email);
}
/**
 * Validate Swedish phone number
 *
 * @param phone
 * @returns boolean
 */
function isValidPhone(phone) {
    return /^(([+]46)\s*(7|07)|07)[02369]\s*(\d{4})\s*(\d{3})$/.test(phone);
}
/**
 * Check if error is a backend error
 *
 * @param error unknown
 * @returns boolean
 */
function isBackendError(error) {
    return (typeof error === 'object' &&
        error !== null &&
        'Message' in error &&
        typeof error.Message === 'string' &&
        'StatusCode' in error &&
        typeof error.StatusCode === 'number');
}
/**
 * Check if object is a person object
 *
 * @param obj unknown
 * @returns boolean
 */
function isPersonObject(obj) {
    return (typeof obj === 'object' &&
        obj !== null &&
        'Company' in obj &&
        typeof obj.Company === 'string' &&
        'Email' in obj &&
        typeof obj.Email === 'string' &&
        'FirstName' in obj &&
        typeof obj.FirstName === 'string' &&
        'LastName' in obj &&
        typeof obj.LastName === 'string' &&
        'MobilePhone' in obj &&
        typeof obj.MobilePhone === 'string' &&
        'Position' in obj &&
        typeof obj.Position === 'string');
}
